/**
 =========================================================
 * Material Dashboard 2 React - v2.0.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2021 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */


import axios from '../../../config/axios'
import {useState, useEffect, useContext} from "react";
import {useNavigate, useParams} from "react-router-dom";
// react-router-dom components
import {Link} from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

//Mascara
import InputMask from "react-input-mask";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

import CandidatoContext from "../../../context/candidato/candidatoContext";

// Images
import bgImage from "assets/images/bgConcurso_cropped.jpeg";


function Basic(props) {
    const {candidatoState, candidatoDispatch} = useContext(CandidatoContext);
    const [erro, setErro] = useState(false);
    const navigate = useNavigate();
    const params = useParams();
    const [login, setLogin] = useState({num_cand: '', cpf: '', concurso: params.concurso});
    const [tipo, setTipo] = useState({tipo: ''});

    useEffect(() => {
        (async () => {
            //Pega as query strings
            let query = new URLSearchParams(window.location.search)
            setTipo({tipo: query.get('tipo')});
            try {
                let response = await axios('/concurso', {params: {concurso: params.concurso}});
                candidatoDispatch({type: 'NOVO_CONCURSO', payload: response.data.concurso});

            } catch (error) {
                candidatoDispatch({type: 'CONCURSO_NAO_ENCONTRADO'});
            }

        })();
    }, [])


    const envia_login = async (event) => {
        event.preventDefault();
        setErro(false);

        try {
            console.log(tipo)
            let response = await axios.post('/candidato/login', {
                num_cand: tipo.tipo ==='impugnacao' ?'1234567-8': login.num_cand,
                cpf: login.cpf,
                concurso: login.concurso,
                tipo: tipo.tipo ?? ''
            })
            candidatoDispatch({type: 'LOGIN', payload: response.data.token});

            if (params.origem === 'consulta_rec_res_simples')
                return navigate(`/consulta_rec_res`);

            if (params.origem === 'consulta_rec_res_cartao')
                return navigate(`/consulta_rec_res_cartao`);

            if (params.origem === 'consulta_rec_res_tabela')
                return navigate(`/consulta_rec_res_tabela`);

            if (params.origem === 'consulta_rec_res_link')
                return navigate(`/consulta_rec_res_link`);

            return navigate(`/${login.concurso}/inscricao`);

        } catch (e) {
            setErro(true);
            return null;
        }
    }

    const validacao = (erro) => {
        return (erro && <MDBox
            mb={2}
            style={{textAlign: 'center'}}
            coloredShadow='error' bgColor="error" borderRadius='5px' variant={'contained'}>
            <MDTypography variant="h6" color="white">
                Verifique inscrição e/ou cpf!
            </MDTypography>
        </MDBox>);
    }

    return (<BasicLayout
        image={bgImage}>
        <Card>
            <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center"
            >
                <img style={{borderRadius: '5px', backgroundColor: 'white', padding: '10px', width: '200px'}}
                     src={candidatoState.concurso.logo}/>
                <MDTypography variant="h6" color="white" mt={1}>
                    {candidatoState.concurso.edital}
                </MDTypography>

            </MDBox>
            <MDBox pt={4} pb={3} px={3}>
                {validacao(erro)}
                <MDBox onSubmit={envia_login} component="form" role="form">
                    {tipo.tipo === 'impugnacao' ||
                        <MDBox mb={2}>
                            <InputMask
                                // mask='9999999-9'
                                disabled={false}
                                onChange={e => setLogin({...login, num_cand: e.target.value})}
                                alwaysShowMask={false}
                                value={login.num_cand}
                                maskPlaceholder={" "}>
                                <MDInput type="text"
                                         label="Número de Inscrição" fullWidth/>
                            </InputMask> </MDBox>
                    }

                    <MDBox mb={2}>
                        <InputMask
                            mask='999.999.999-99'
                            disabled={false}
                            onChange={e => setLogin({...login, cpf: e.target.value})}
                            alwaysShowMask={false}
                            value={login.cpf}
                            maskPlaceholder={" "}>
                            <MDInput type="text" label="CPF" fullWidth/>
                        </InputMask>


                    </MDBox>
                    <MDBox mt={4} mb={1}>
                        <MDButton type="submit" variant="gradient" color="info" fullWidth>
                            Entrar
                        </MDButton>
                    </MDBox>
                </MDBox>
            </MDBox>
        </Card>
    </BasicLayout>);
}

export default Basic;
